import { SET_ELCALARM_RECORDS } from '../constants/ELCAlarmDataConstants';

const initialState = {
  alarmDatas: {
    list: [],
    count: 0,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ELCALARM_RECORDS: {
      return {
        ...state,
        alarmDatas: {
          list: action.payload.list,
          count: action.payload.count,
        },
      };
    }

    default: {
      return state;
    }
  }
}
